import type { Page } from '@/domain/model/Page';
import type { GatewayCredencial, UpsertGatewayCredencialCommand } from '@/domain/model/GatewayCredencial';
import type { GatewayCredencialGateway, ListGatewayCredenciaisParams } from '@/application/port/out/GatewayCredencialGateway';
import type {
  ListGatewayCredenciaisUseCase, CreateGatewayCredencialUseCase,
  UpdateGatewayCredencialUseCase, DeleteGatewayCredencialUseCase,
} from '@/application/port/in/GatewayCredencialUseCase';

export class ListGatewayCredenciais implements ListGatewayCredenciaisUseCase {
  constructor(private readonly g: GatewayCredencialGateway) {}
  execute(params: ListGatewayCredenciaisParams): Promise<Page<GatewayCredencial>> { return this.g.list(params); }
}
export class CreateGatewayCredencial implements CreateGatewayCredencialUseCase {
  constructor(private readonly g: GatewayCredencialGateway) {}
  execute(cmd: UpsertGatewayCredencialCommand): Promise<GatewayCredencial> { return this.g.create(cmd); }
}
export class UpdateGatewayCredencial implements UpdateGatewayCredencialUseCase {
  constructor(private readonly g: GatewayCredencialGateway) {}
  execute(id: string, cmd: UpsertGatewayCredencialCommand): Promise<GatewayCredencial> { return this.g.update(id, cmd); }
}
export class DeleteGatewayCredencial implements DeleteGatewayCredencialUseCase {
  constructor(private readonly g: GatewayCredencialGateway) {}
  execute(id: string): Promise<void> { return this.g.remove(id); }
}
